module.exports = {
    navigation: {
        nav: ['HOME', 'ABOUT', 'PRODUCTS', 'PROGRESS', 'SHOPPING', 'MALL', 'CONTACT US', 'LANGUAGE'],
        company: location.hostname === 'wwww.xiandanmall.com' ?  'Hope U (Chengdu) Network Technology Co.,Ltd.' : 'CHENGDU XIANDAN MALL E-COMMERCE CO., LTD.',
        shopping: 'XIAN DAN ONLINE',
        platform: 'SHOPPING MALL',
        go: 'BUY NOW'
    },
    mallTitle: {
        title: 'Xiandan',
        words: 'Xian Dan is a cross-border online e-commerce platform, mainly selling cosmetics, snacks, health care products. The business model of the platform is Platform Supply plus Store Manager Sell. Store managers have the full control on pricing. With each store manager\'s exclusive customer base,  the profit is decided by the selling price over cost offered by the platform. The platform guarantees official and legal supply, and puts an end to fake or illegal source.  Tax bonded warehouse ensures us premium tax offer, so that we have a favorable cost over supermarkets, official stores. The platform places heavy fine over fake products to win over the faith with our store managers and clients.',
        contact: 'CONTACT US'
    },
    title: {
        sale: 'You can buy',
        course: 'PROGRESS',
        pay: 'Purchase goods',
        contact: 'Contact'
    },
    goods: {
        columns: ['COSMETICS PRODUCTS', 'GROCERY', 'BABY PRODUCTS', 'HEALTH CARE PRODUCTS']
    },
    rotationChart: {
        register: {
            title: 'home.progress.list.2.title',
            time: '2019.01',
            complete: 'home.progress.list.2.content'
        },
        start: {
            title: 'PROJECT STARTING',
            time: '2018.10',
            complete: 'The project started, preparing various documents and system development work.'
        },
        access: {
            title: 'home.progress.list.3.title',
            time: '2019.02',
            complete: 'home.progress.list.3.content'
        },
        warehouse: {
            title: 'Bonded Warehouse',
            time: '2019.03',
            complete: 'Establish cooperative relationship with Sichuan Huitong World Logistics Co., Ltd.。'
        },
        choice: {
            title: 'Product stock',
            time: '2019.04',
            complete: 'Contact Japanese suppliers for stock-up.'
        },
        product: {
            title: 'Platform on-line',
            time: '2019.06',
            complete: 'Goods arrive at Shuangliu Airport, complete customs clearance and enter bonded warehouse smoothly.'
        }
    },
    purchaseGoods: {
        public: 'Xiandan WeChat official account',
        title: 'At present, we have opened WeChat official account online purchase and "scan code purchase" two ways to purchase. Please scan the QR code on the left to follow us on the WeChat official account. There are thousands of products.'
    },
    contact: {
        address: {
            title: 'Address',
            details: 'Room 1, 3/F, Unit 1, Building 1, No 366, North Section Hupan Road, Tianfu New Area, Chengdu, Sichuan Province, China.'
        },
        telephone: {
            title: 'Contact number'
        },
        mail: {
            title: 'E-Mail'
        },
        input: {
            name: 'name',
            mail: 'mailbox',
            theme: 'theme',
            say: 'Say something',
            send: 'send message'
        }
    },
    footer: [
        {
            company: 'HOPE U (CHENGDU) NETWORK TECHNOLOGY CO., LTD',
            keep: '川公网安备 51011502000300号',
            record: '蜀ICP备18037207号-1'
        },
        {
            company: 'CHENGDU XIANDAN MALL E-COMMERCE CO., LTD.',
            keep: '川公网安备 51011502000300号',
            record: '蜀ICP备19029040号-1'
        }
    ]
}
